import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { authManager } from '../utils/auth';

const Base_Url = process.env.REACT_APP_API_BASE_URL;

function DropdownOptions() {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pagination, setPagination] = useState({});
    const [deleteId, setDeleteId] = useState(null);
    const [deleting, setDeleting] = useState(false);
    const [filters, setFilters] = useState({
        type: '',
        search: ''
    });

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        fetchOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchOptions = async (page = 1) => {
        try {
            setLoading(true);
            const queryParams = new URLSearchParams({
                page,
                limit: 50,
                ...(filters.type && { type: filters.type }),
                ...(filters.search && { search: filters.search }),
            });

            const res = await authManager.authenticatedFetch(
                `${Base_Url}/admin/dropdown-options/list?${queryParams}`
            );
            const data = await res.json();

            if (data.status === 'success') {
                setOptions(data.data.options || []);
                setPagination(data.data.pagination || {});
            } else {
                toast.error(data.message || 'Failed to fetch dropdown options');
            }
        } catch (error) {
            console.error('Error fetching dropdown options:', error);
            toast.error('Error fetching dropdown options');
        } finally {
            setLoading(false);
        }
    };

    const handleToggleActive = async (option) => {
        try {
            const res = await authManager.authenticatedFetch(
                `${Base_Url}/admin/dropdown-options/${option._id}`,
                {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ isActive: !option.isActive })
                }
            );

            const data = await res.json();
            if (data.status === 'success') {
                toast.success(`Option ${!option.isActive ? 'activated' : 'deactivated'}`);
                fetchOptions(pagination.page || 1);
            } else {
                toast.error(data.message || 'Update failed');
            }
        } catch (error) {
            console.error('Error toggling option:', error);
            toast.error('Error toggling option');
        }
    };

    const handleDelete = async () => {
        try {
            setDeleting(true);
            const res = await authManager.authenticatedFetch(
                `${Base_Url}/admin/dropdown-options/${deleteId}`,
                { method: 'DELETE' }
            );

            const data = await res.json();
            if (data.status === 'success') {
                toast.success('Dropdown option deleted successfully');
                setDeleteId(null);
                window.$?.('#modaldelete_option').modal('hide');
                fetchOptions(pagination.page || 1);
            } else {
                toast.error(data.message || 'Delete failed');
            }
        } catch (error) {
            console.error('Error deleting option:', error);
            toast.error('Error deleting option');
        } finally {
            setDeleting(false);
        }
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    const handleSearch = (e) => {
        e.preventDefault();
        fetchOptions(1);
    };

    const handleClearFilters = () => {
        setFilters({ type: '', search: '' });
        setTimeout(() => fetchOptions(1), 0);
    };

    return (
        <>
            <ToastContainer autoClose={3000} />
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 txt_lft">Dropdown Options</h1>
                        </div>
                        <div className="col-sm-6 txt_rgt">
                            <Link to="/dropdownOptionsAdd" className="btn btn-blue">
                                Add Dropdown Option
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
                <div className="container-fluid">
                    {/* Filters */}
                    <div className="card mb-3">
                        <div className="card-body">
                            <form onSubmit={handleSearch} className="row align-items-end">
                                <div className="col-md-3">
                                    <label>Type</label>
                                    <select
                                        className="form-control"
                                        name="type"
                                        value={filters.type}
                                        onChange={handleFilterChange}
                                    >
                                        <option value="">All</option>
                                        <option value="military_status">Military Status</option>
                                        <option value="military_branch">Military Branch</option>
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <label>Search</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="search"
                                        value={filters.search}
                                        onChange={handleFilterChange}
                                        placeholder="Search by value or label..."
                                    />
                                </div>
                                <div className="col-md-5">
                                    <button type="submit" className="btn btn-primary mr-2">
                                        Filter
                                    </button>
                                    <button type="button" className="btn btn-secondary" onClick={handleClearFilters}>
                                        Clear
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                    {/* Table */}
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="table-responsive">
                                {loading ? (
                                    <div className="text-center p-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                ) : options.length > 0 ? (
                                    <>
                                        <table width="100%" className="table table-striped table-bordered txt_lft">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '50px' }}>Order</th>
                                                    <th style={{ width: '150px' }}>Type</th>
                                                    <th>Value</th>
                                                    <th>Label</th>
                                                    <th style={{ width: '100px' }}>Active</th>
                                                    <th style={{ width: '100px' }}>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {options.map((option) => (
                                                    <tr key={option._id}>
                                                        <td>{option.displayOrder}</td>
                                                        <td>
                                                            <code>{option.type}</code>
                                                        </td>
                                                        <td>{option.value}</td>
                                                        <td>{option.label}</td>
                                                        <td align="center">
                                                            <div className="toggle-switch">
                                                                <label className="switch">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={option.isActive}
                                                                        onChange={() => handleToggleActive(option)}
                                                                    />
                                                                    <span className="slider"></span>
                                                                </label>
                                                                <span className="toggle-label">
                                                                    {option.isActive ? 'On' : 'Off'}
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div align="center">
                                                                <Link to={`/dropdownOptionsAdd/${option._id}`} className="crsr_pntr">
                                                                    <i className="fa-solid fa-pen mr-2" title="Edit" />
                                                                </Link>
                                                                <button
                                                                    className="crsr_pntr btn btn-link p-0"
                                                                    onClick={() => setDeleteId(option._id)}
                                                                    data-toggle="modal"
                                                                    data-target="#modaldelete_option"
                                                                >
                                                                    <i className="fa-solid fa-trash-can" title="Delete" />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>

                                        {/* Pagination */}
                                        {pagination.pages > 1 && (
                                            <nav className="mt-3">
                                                <ul className="pagination justify-content-center">
                                                    <li className={`page-item ${pagination.page === 1 ? 'disabled' : ''}`}>
                                                        <button
                                                            className="page-link"
                                                            onClick={() => fetchOptions(pagination.page - 1)}
                                                            disabled={pagination.page === 1}
                                                        >
                                                            Previous
                                                        </button>
                                                    </li>
                                                    {[...Array(pagination.pages)].map((_, i) => (
                                                        <li key={i} className={`page-item ${pagination.page === i + 1 ? 'active' : ''}`}>
                                                            <button
                                                                className="page-link"
                                                                onClick={() => fetchOptions(i + 1)}
                                                            >
                                                                {i + 1}
                                                            </button>
                                                        </li>
                                                    ))}
                                                    <li className={`page-item ${pagination.page === pagination.pages ? 'disabled' : ''}`}>
                                                        <button
                                                            className="page-link"
                                                            onClick={() => fetchOptions(pagination.page + 1)}
                                                            disabled={pagination.page === pagination.pages}
                                                        >
                                                            Next
                                                        </button>
                                                    </li>
                                                </ul>
                                            </nav>
                                        )}
                                    </>
                                ) : (
                                    <div className="text-center p-5">
                                        <p>No dropdown options found</p>
                                        <Link to="/dropdownOptionsAdd" className="btn btn-primary">
                                            Create your first option
                                        </Link>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Delete Modal */}
            <div className="modal fade" id="modaldelete_option" tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirm Delete</h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this dropdown option?</p>
                            <p className="text-muted small">
                                This action cannot be undone. Removing an option that's already stored on a user
                                record won't affect that record, but it will no longer appear as a choice.
                            </p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger"
                                onClick={handleDelete}
                                disabled={deleting}
                            >
                                {deleting ? 'Deleting...' : 'Delete'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DropdownOptions
